export const FORM_ERROR = 'FORM_ERROR'
export const RESET_FORM = 'RESET_FORM'
export const RESET_SINGLE_FORM = 'RESET_SINGLE_FORM'
export const REGISTER_FORM = 'REGISTER_FORM'
export const RESET_POSTCODE_ERRORS = 'RESET_POSTCODE_ERRORS'
